<app-temperature-chart-tile
  [title]="title"
  [applicationId]="applicationId"
  [series]="series$ | async"
  [dataPoints$]="dataPoints$"
  [userTrackingPeriodOptions]="userTrackingPeriodOptions"
>
</app-temperature-chart-tile>
